import { TABLE_CELL_PADDING_LEFT, TABLE_CELL_PADDING_RIGHT } from "@/pages/home/_config/config";

export const PAGE_TYPE_PRESET = 'preset';
export const PAGE_TYPE_PATH = 'path';
export const PAGE_TYPE_TABLEAU = 'tableau';
export const PAGE_TYPE_WORKBOOK = 'workbook_url';
export const PAGE_TYPE_PDF = 'pdf';
export const PAGE_TYPE_URL = 'url';
export const PAGE_TYPE_DASHBOARD_CUSTOM = 'dashboard_custom';
export const PAGE_TYPE_PUBLIC_URL = 'public_url';
export const PAGE_TYPE_DATALAB = 'datalab';
export const PAGE_TYPE_DASHAPP = 'dashApp';
export const PAGE_TYPE_LOOKER = 'looker';
export const PAGE_TYPE_COS_URL = 'cos_url';
export const PAGE_TYPE_OUT_PATH = 'outPath';
export const PAGE_TYPE_OUT_URL = 'out_url';
export const PAGE_TYPE_AUTH_PATH = 'auth_path';

export const PUBLIC_URL_PAGE_PATH = 'web/report';
export const DATALAB_PAGE_PATH = 'datalab/report';
export const PRESET_PAGE_PATH = 'preset/report';
export const TABLEAU_PAGE_PATH = 'tableau/report';
export const PDF_PAGE_PATH = 'pdf/report';
export const COS_URL_PAGE_PATH = 'cos/report';
export const CUSTOM_DASHBOARD_PAGE_PATH = 'datalab/customDashboard';
export const DASHAPP_PAGE_PATH = 'dashApp/report';
export const LOOKER_PAGE_PATH = 'looker/report';
export const AUTH_PATH_PAGE_PATH = 'authPath/report';

// 每种页面对应后端的参数key
export const PAGE_URL_KEY = {
  [PAGE_TYPE_PATH]: 'path',
  [PAGE_TYPE_WORKBOOK]: 'workbook_url',
  [PAGE_TYPE_URL]: 'url',
  [PAGE_TYPE_DATALAB]: 'dashboard_uuid',
  [PAGE_TYPE_PRESET]: 'preset_id',
  [PAGE_TYPE_PDF]: 'url',
  [PAGE_TYPE_LOOKER]: 'looker_url',
  [PAGE_TYPE_AUTH_PATH]: 'path',
  [PAGE_TYPE_COS_URL]: 'cos_url',
  [PAGE_TYPE_DASHAPP]: 'dashApp_url'
};

// 报表的路径前缀
export const PAGE_PATH_MAP = {
  [PAGE_TYPE_PRESET]: PRESET_PAGE_PATH,
  [PAGE_TYPE_PUBLIC_URL]: PUBLIC_URL_PAGE_PATH,
  [PAGE_TYPE_PDF]: PDF_PAGE_PATH,
  [PAGE_TYPE_DASHAPP]: DASHAPP_PAGE_PATH,
  [PAGE_TYPE_LOOKER]: LOOKER_PAGE_PATH,
  [PAGE_TYPE_DASHBOARD_CUSTOM]: CUSTOM_DASHBOARD_PAGE_PATH,
  [PAGE_TYPE_COS_URL]: COS_URL_PAGE_PATH,
  [PAGE_TYPE_AUTH_PATH]: AUTH_PATH_PAGE_PATH,
  [PAGE_TYPE_DATALAB]: DATALAB_PAGE_PATH,
  default: TABLEAU_PAGE_PATH
};

export const SYS_ADMIN = 'sys_admin';  // 系统管理员  所有权限（除三方游戏）
export const GAME_MANAGER = 'game_manager'; // feature及mydashboard菜单下报表增删改权限
export const SYS_MANAGER = 'sys_manager';  // 经分管理者 	可以查看所有报表

export const BUSINESS_TYPE_GAME = 'game';
export const BUSINESS_TYPE_OTHER = 'other';
export const BUSINESS_TYPE_FEATURE = 'feature';
export const BUSINESS_TYPE_MYDASHBOARD = 'mydashboard';

export const FOLDER_NAME_FAVORITES = 'Favorite Page';
export const FOLDER_NAME_MYDASHBOARD = 'My dashboard';

export const MENU_CONTROL_PERMISSION = [SYS_ADMIN, GAME_MANAGER];
export const MENU_PERMISSION = [SYS_ADMIN];
export const BUSINESS_TYPE_PERMISSION = {
  [SYS_ADMIN]: [BUSINESS_TYPE_GAME, BUSINESS_TYPE_OTHER, BUSINESS_TYPE_FEATURE, BUSINESS_TYPE_MYDASHBOARD],
  [GAME_MANAGER]: [BUSINESS_TYPE_FEATURE],
  default: []
};

export const TAB_MAP = {
  country: 'Countries',
  region: 'Regions',
  zone: 'Zones',
  os: 'Platform',
  lang: 'Language',
  network_type: 'Network_Type',
  bundle: 'Bundle'
};

export const FILTER_KEY_MAP = {
  zone: 'zone_list',
  channel: 'channel_list',
  system: 'os_list',
  lang: 'lang_list',
  mediaChannel: 'channel_list',
  networkType: 'network_list',
  appVersion: 'app_version_list',
  memory: 'memory_list',
  storeChannel: 'store_channel_list',
  stage: 'stage_list',
  category: 'category_list',
  product: 'product_list',
  bundle: 'bundle_list',
  churn_level: 'churn_level_list',
  ab_test: 'ab_test_list'
};

export const PLATFORM_MAP = {
  // "steam": '#326282FF',
  // "playstation": '#0070D1FF',
  // 'xbox': "#008C00FF",
  // 'epic': "#FFC600FF",
  // 'epics': "#FFC600FF",
  // 'nintendo': "#E70012FF",
  // 'others': "#A6C9FF",
  "steam": '#326282',
  "steammac": '#326282',
  "steam(非mac)": '#326282',
  "playstation": '#587EDB',
  'xbox': "#4DAB7D",
  'epic': "#FFC600",
  'epics': "#FFC600",
  'nintendo': "#F17C86",
  'heybox': "#6E7794",
  'scarlett': '#B5EFFF',
  'pclauncher': '#307DA6',
  'officialwebsite': '#B70B25',
  '官网(非mac)': '#B70B25',
  '官网(mac)': '#B70B25',
  'officialwebsite(mac)': '#B70B25',
  'kakao': '#FFE76E',
  'others': "#5EC8F1",
  '其他': "#5EC8F1",
};

export const DEFAULT_METRICS_TABLE_HEIGHT = 527;
export const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50];
export const PUBLIC_HEIGHT = 350;

export const BREAK_DOWN_TAB_LIST = [
  { text: "Country", value: "country" },
  { text: "Region", value: "region" },
  { text: "Zone", value: "zone" },
];

export const COLOR_ARR =  ['#5086F3', '#69D19C', '#6E7794', '#F8D74D', '#7F6FF1', '#5EC8F1', '#AD53D4', '#F19E55', '#488E89', '#F17C86', '#B8BED1', '#45AF6A', '#9AA5C9', '#BE9737', '#9C8CEE', '#3EAFD7', '#E171BD', '#CE8038', '#6BB1AF', '#E5727C', '#ABD2FF', '#78E198', '#CDD8FD', '#F3C866', '#D4C0FF', '#7BE2FF', '#FFA7F3', '#FBB167', '#9EE5E2', '#FFAAB3', '#D4E8FF', '#92FBB0', '#E5EBFD', '#FFE683', '#F1DCFF', '#99FEFF', '#FFCAFF', '#FFD286', '#B9FFFE', '#FFCAD2'];

export const DEEP_COLORS = [
  "#5086f3", "#69d19c", "#6e7794", "#f5d242", "#7f6ff1", "#5ec8f1", "#ad53d4", "#f19e55", "#488e89", "#f17c86"
];

export const LIGHT_COLORS = [
  "#a6c9ff", "#c0ebd2", "#b8bed1", "#fff196", "#d2c8fd", "#b5efff", "#dfb2ed", "#ffd8ab", "#a9c7c3", "#ffcccc"
];

/**
 * Key Days 默认值
 */
export const KEY_DAYS_DEFAULT_VALUE = 0;

/**
 * Key Days 筛选器选项组
 */
export const KEY_DAYS_OPTIONS = [
  {
    value: 0,
    text: 'Key Days',
    tooltip: '',
  },
  {
    value: 30,
    text: '1 ~ 30 Days',
    tooltip: '',
  },
  {
    value: 60,
    text: '1 ~ 60 Days',
  },
  {
    value: 90,
    text: '1 ~ 90 Days',
  },
  {
    value: 180,
    text: '1 ~ 180 Days',
  },
];

export const filterTimeTypeObj = {
  DAY: 'Day',
  MONTH: 'Month',
  WEEK: 'Week',
};

export const timeTypeObj:any = {
  Day: 'YYYY-MM-DD',
  Week: 'YYYY-MM-DD',
  Month: 'YYYY-MM'
};

export const timeType:any = {
  date: 'Day',
  week: "Week",
  month: "month"
};

export const ORGANIZATION_FUN = 'Funcom';
export const DEMO_GAME_LIST = ['demo', 'pc_demo'];

export const FILTER_TYPE_COMMON = 'commom';
export const FILTER_TYPE_SEFL = 'self';

export const LANGUAGE_EN = 'en-US';
export const LANGUAGE_CN = 'zh-CN';

export const ALL_VALUE = '255';

export const LANGUAGE_LIST = [
  {
    value: LANGUAGE_EN,
    text: 'English'
  },
  {
    value: LANGUAGE_CN,
    text: '简体中文'
  }
];

export const LOCAL_LANGUAGE_KEY = '_LOCAL_LANGUAGE_KEY';

export const WEEK_DAY_ARR = ['Mon.','Tue.','Wed.','Thu.','Fri','Sat','Sun'];

export const MATCH_ROUTE_REG = /\/dashboard\/game\/([0-9a-z_])+\//;

export const PUBG_GAME_CODE_LIST = ['i_game', 'i_game_global', 'i_game_brazil', 'i_game_ee', 'i_game_jpkr','i_game_mena', 'i_game_na', 'i_game_sa', 'i_game_sea', 'i_game_ssa', 'i_game_tw', 'i_game_vn', 'i_game_we'];

export const DOWNLOAD_GUIDE_LINK = 'https://docs.google.com/document/d/10tDENjBK-NYMpNPN1LesvJdN80YKtiTYGH1KOvsSx1w/edit?usp=sharing';

export const POE_DEMO_GAME_CODE_LIST = ['poe2'];

export const TIMETABS: any = [
  { tabName: 'Day' },
  { tabName: 'Week' },
  { tabName: 'Month' },
];

export const PERIODTIMEOBJ:any = {
  Day: 'daily',
  Week: 'weekly',
  Month: 'monthly'
};

export const PERIOD_MAP:any = {
  date: 'daily',
  week: 'weekly',
  month: 'monthly'
};

export const CHART_TYPE: {
  [key: string]: 'pie' | 'bar' | 'line' | 'table';
} = {
  BAR: 'bar',
  LINE: 'line',
  PIE: 'pie',
  TABLE: 'table'
};

export const BREAK_DOWN_CONFIG = {
  register: {
    isHaveBar: true,
    isHaveLine: true,
    isHavePie: true,
    isHaveShare: true,
  },
  active: {
    isHaveBar: true,
    isHaveLine: true,
    isHavePie: true,
    isHaveShare: true,
  },
  cpa: {
    isHaveBar: true,
    isHaveLine: true,
    isHavePie: false,
    isHaveShare: false,
  },
  ltv: {
    isHaveBar: true,
    isHaveLine: true,
    isHavePie: false,
    isHaveShare: false,
  },
  churn: {
    isHaveBar: true,
    isHaveLine: true,
    isHavePie: true,
    isHaveShare: true,
  },
  inGameRevenue: {
    isHaveBar: true,
    isHaveLine: true,
    isHavePie: true,
    isHaveShare: true,
  },
  platformSalesBreakdown: {
    isHaveBar: true,
    isHaveLine: true,
    isHavePie: false,
    isHaveShare: true,
  },
  platformSalesRevenue: {
    isHaveBar: true,
    isHaveLine: true,
    isHavePie: true,
    isHaveShare: true,
  },
};

export const INIT_COUNTRY_REGION_DATA = { tableData: [], chartData: [] };

export const LANGUAGE_MAP:any = {
  'zh-CN': 'zh',
  'en-US': 'en'
};

export const DEFAULT_WIDTH = 250;
export const MAX_WIDTH = 400;
export const GAME_LIST_WIDTH = 460;

export const DB_DASHBOARD_LOCAL_CURRENT_GAME_KEY = '__db_dashboard_current_game__';
export const DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY = '__dbd_dashboard_filter_save_scheme__';
export const DB_DASHBOARD_LOCAL_FILTER_SAVE_OUT_SCHEME_KEY = '__dbd_dashboard_filter_save_out_scheme__';
export const DB_DASHBOARD_LOCAL_VS_BENCHMARK_RED_DOT_IS_IN_STORAGE_KEY = '__dbd_vs_benchmark_red_dot_is_in_storage__';

export const SOP_GAME_ARR = ['sop_pc'];

export const LOG_SYSTEM_TYPE = 'dashboard_pc_v2';

// 和产品确认只处理gamecode为nikke的游戏
export const NIKKE_COMPETITOR_GAME = ["nikke"];
export const NIKKE_MENU_MSG = [
  {
    name_cn: '日区排行榜',
    name_en: 'Japan Top Charts',
    page_type: PAGE_TYPE_OUT_PATH,
    url: '/intelligence/topCharts/mobileGames?rangeTime=day,2023-01-01,2023-12-31&region=jp&dataSource=appannie&pageSize=50&topSelect=10&order=desc&orderMetric=revenue'
  },
  {
    name_cn: '日区游戏洞察',
    name_en: 'Japan Game Insight',
    page_type: PAGE_TYPE_OUT_PATH,
    url: '/intelligence/MarketProfile/Overview/detail?marketName=Japan&marketNameEn=jp&pageId=MarketProfilMobile&isAnnie=0'
  },
];

export const EXTRA_FILTER_KEY_MAP = {
  metric: 'metric',
  regionType: 'by_type',
  by_type: 'by_type',
  byType: 'by_type'
};

// 宽表指标列宽度设置
// 数字代表位数 (不包含逗号, 百分号, 包含小数点)
// 位数与列名长度 不等时, 取较长的宽度
export const columnWidth = {
  twentyFour: 300 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  twentyThree: 290 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  twentyTwo: 280 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  twentyOne: 270 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  twenty: 260 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  nineteen: 250 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  eighteen: 240 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  seventeen: 230 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  sixteen: 220 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  fifteen: 210 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  thirteen: 200 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  twelve: 190 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  ten: 180 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  nine: 170 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  eight: 160 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  seven: 152 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  six: 150 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  five: 145 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  four: 115 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  three: 100 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
};

export const upDownWidth = 75;

export const timeTypeTrans:any = {
  date: 'Day',
  week: "Week",
  month: "Month"
};

export const textLocalConfig = [
  {
    id: "common_date",
    key: "date",
  },
  {
    id: "common_contrast",
    key: 'contrast'
  },
  {
    id: "comparison_analysis_date_comparison_key_metrics_comparison",
    key: "dateTitle"
  },
  {
    id: "comparison_analysis_country_comparison_key_metrics_ranking",
    key: "countryTitle"
  },
  {
    id: "common_Zone",
    key: "zone",
  },
  {
    id: "common_Region",
    key: "region",
  },
  {
    id: "common_Country",
    key: "country",
  },
  {
    id: "common_System",
    key: "system",
  },
  {
    id: "common_Channel",
    key: "channel",
  },
  {
    id: "common_Bundle",
    key: "bundle",
  },
  {
    id: "common_Sum",
    key: "sum",
  },
  {
    id: "common_Max",
    key: "max",
  },
  {
    id: "common_Min",
    key: "min",
  },
  {
    id: "common_Average(remove_Null)",
    key: "avg_no_null",
  },
  {
    id: "common_Average(remove_Null&0)",
    key: "avg_no_null_zero"
  },
  {
    id: "common_Count",
    key: "count"
  },
  {
    id: "common_Language",
    key: "language"
  },
  // 夜莺时间对比 留存追踪对比宽表
  {
    id: "common_Average",
    key: "avg",
  },
  {
    id: "common_Churn_level",
    key: "churn_level"
  },
];

export const IS_NOT_REQ_SELECTOR_PAGE = [
  'monetization/revenue/platformSalesBreakdown',
  'monetization/salesOverview',
  'monetization/salesOverview/revenue',
  'monetization/salesOverview/breakdown',
  'monetization/salesBreakdown',
  'comparisonAnalysis/eventComparison',
  'eventAnalysis/eventAnalysis',
  'wow/index',
  'realtime/iaaRevenue',
  'realtime/iaaRevenue/overview',
  'realtime/iaaRevenue/byPlatformRegionAdFormat',
  'realtime/uaSpend',
  'realtime/uaSpend/overview',
  'realtime/uaSpend/byPlatformRegionMediaChannel',
  'realtime/overview',
  'realtime/overview/overall',
  'realtime/overview/newUser',
];

export const IS_NOT_REQ_SELECTOR_PAGE_REALTIMES = [
  'realtime/users',
  'realtime/users/users',
  'realtime/users/byCountryRegionZone',
  'realtime/users/changeAnalysis',
  'realtime/users/dataDownload',
];

export const IS_NOT_REQ_SELECTOR_PAGE_CONDITION = [
  'engagement/churn',
  'comparisonAnalysis/dateComparison',
];

// 现有框架类型
export const DATA_FRAME_LIST = ['mobile','pc','casual'];

// 临时处理未配置化但是使用了pc_inflexion的夜莺相关页面
export const PAGE_SHOW_TYPE_LIST = ['mobile','pc','nightingale'];

// pc_dev_nightingale为开发和测试环境的测试用gamecode
export const NIGHTINGALE_GAME = ['pc_nightingale', 'pc_dev_nightingale'];

export const demoPaths = [ '/dashboard/game/demo', '/dashboard/game/pc_demo', '/datalab/pc_demo', '/datalab/demo'];

export const DL2_GAME_LIST = ['dl2'];

/**
 * SecureIframeRender 灰度开关。
 * - 默认 true：public_url 类报表走签发 + URL 绑定的 SecureIframeRender。
 * - 联调出问题、要紧急回滚时，改成 false 后发版即可立刻退回裸 iframe 行为
 *   （会丢失第三方鉴权能力，仅作应急回滚）。
 *
 * 后期接入运维平台配置中心时把它换成异步加载的 feature flag 即可。
 */
export const SECURE_IFRAME_ENABLED = true;

/**
 * 需要访问用户本机 loopback 服务（如 UE 引擎本地 HTTP 接口 127.0.0.1:xxxx）的第三方嵌入域名白名单。
 * Chrome/Edge 142+ 的 Local Network Access 限制默认禁止跨域 iframe 发起 loopback/本地网络请求，
 * 命中该白名单的第三方页面才会给 <iframe allow> 显式开放 local-network / loopback-network 权限。
 * 兼容写法同时保留旧版 Chrome（142-144）使用的 local-network-access。
 */
export const LOOPBACK_ACCESS_ALLOWED_HOSTS = ['infiperf.intlgame.com'];

export const IFRAME_ALLOW_LOOPBACK_ACCESS =
  'local-network-access; local-network; loopback-network';

export const BLACK_GAME_LIST = ['poe2', 'poe1', 'dl', 'dl2', 'thebeast', 'gtfo',  'Dune', 'pool', 'd5', 'bishop', 'dune', 'warframe_wegame', 'warframe_all', 'pc_nightingale', 'rebirth', 'warframe', 'conan_pc', 'funcom'];

export const FRAME_TYPE_MAP = {
  pc: 'PC&Console',
  mobile: 'Mobile'
};

// 名称跟系统权限映射
export const SYSTEM_PERMISSIONS_MAP: any = {
  Intelligence: "intelligence_pc",
  Opinions: "opinion_pc",
};

// 导出int格式化字段数组
export const INT_FORMAT_ARRAY = ['int', 'thousandsInit', 'bmk', 'bm', 'intBmk'];

// 维度再宽表中的宽度处理
export const ACCUMULATE_WIDTH_MAP: {
  [key: string]: {
    cn: number;
    en: number;
  };
} = {
  'pv_threshold': {
    'cn': 156,
    'en': 220,
  },
  'network_type': {
    'cn': 200,
    'en': 220,
  }
};

// 维度再宽表中的宽度处理
export const ACCUMULATE_ALIGN_MAP: {
  [key: string]: string;
} = {
  'pv_threshold': 'right'
};

/**
 * Rainbow 接口根据游戏 flags 传递的 flag 参数配置
 * key: flags 中的标识值（userMessage 接口返回，逗号分隔）
 * value: 传给 rainbow/info 接口的 flag 值
 */
export const RAINBOW_FLAG_CONFIG: Record<string, string> = {
  casual_overseas: 'casual_overseas',
};

// 是否显示下载指引
export const SHOW_DOWNLOAD_GUIDE = false;

// LeftMenu 底部外链配置（按 gameCode 展示，新窗口打开链接）
export interface IFooterLinkTooltip {
  en: string;
  cn: string;
}

/** 底部外链支持的 page_type，与左侧菜单 outPath / out_url 一致 */
export type TFooterLinkPageType =
  | typeof PAGE_TYPE_OUT_PATH
  | typeof PAGE_TYPE_OUT_URL;

export interface IFooterLinkItem {
  /** 展示该外链的 gameCode 列表，一条配置可对应多个游戏 */
  gameCodes: string[];
  /**
   * 链接类型
   * - outPath: 根路径相对地址（不含 /v2），打开时 url 原样，如 /as/report/.../index.html
   * - out_url: 完整外链，打开地址为 url 原样
   */
  page_type: TFooterLinkPageType;
  /** outPath 填相对路径；out_url 填完整 URL */
  url: string;
  /** SvgIcon 图标类型 */
  icon: string;
  /** 悬浮提示文案，中英文在配置内直接维护 */
  tooltip: IFooterLinkTooltip;
}

/** 解析后的外链配置（不含 gameCodes） */
export type IFooterLinkConfig = Omit<IFooterLinkItem, 'gameCodes'>;

export const LEFT_MENU_FOOTER_LINK_LIST: IFooterLinkItem[] = [
  {
    gameCodes: ['techland_overview', 'dl', 'dl2', 'dl_the_beast'],
    page_type: PAGE_TYPE_OUT_PATH,
    url: '/as/report/g-aa54cd90-45e7-4b7b-bb27-8a5ddc876a16/6.25/index.html',
    icon: 'knowledge',
    tooltip: {
      en: 'Dashboard Metrics Document',
      cn: '指标手册'
    },
  },
];

